(() => {
  const gridSelector = '.js-LoadMore_Target';
  const itemSelector = '.clc-List_Item';
  const collectionSelector = '.js-LoadMore';
  const storageKey = `bs-collection-state:${window.location.pathname}${window.location.search}`;

  const normalisePath = (href) => {
    try {
      return new URL(href, window.location.origin).pathname;
    } catch (error) {
      return href;
    }
  };

  const readState = () => {
    try {
      return JSON.parse(sessionStorage.getItem(storageKey));
    } catch (error) {
      sessionStorage.removeItem(storageKey);
      return null;
    }
  };

  const isHistoryReturn = () => {
    const navigation = performance.getEntriesByType('navigation')[0];
    return navigation && navigation.type === 'back_forward';
  };

  const restore = () => {
    if (!isHistoryReturn()) return;

    const state = readState();
    if (!state || !state.gridHtml || Date.now() - state.savedAt > 1800000) {
      sessionStorage.removeItem(storageKey);
      return;
    }

    const grid = document.querySelector(gridSelector);
    const collection = document.querySelector(collectionSelector);
    if (!grid || !collection) return;

    history.scrollRestoration = 'manual';
    grid.innerHTML = state.gridHtml;

    const restoredCount = grid.querySelectorAll(itemSelector).length;
    const totalItems = Number(collection.dataset.totalItems || 0);
    const pagination = collection.querySelector('.clc-List_Pagination');

    if (pagination && totalItems && restoredCount >= totalItems) {
      pagination.remove();
    } else if (pagination && state.paginationHtml) {
      pagination.innerHTML = state.paginationHtml;
    }

    const productLink = Array.from(grid.querySelectorAll('a[href*="/products/"]'))
      .find((link) => normalisePath(link.href) === state.productPath);

    requestAnimationFrame(() => requestAnimationFrame(() => {
      if (productLink) {
        productLink.closest(itemSelector).scrollIntoView({ block: 'center' });
      } else {
        window.scrollTo(0, state.scrollY);
      }
      sessionStorage.removeItem(storageKey);
    }));
  };

  restore();

  document.addEventListener('click', (event) => {
    const link = event.target.closest(`${gridSelector} a[href*="/products/"]`);
    if (!link) return;

    const grid = document.querySelector(gridSelector);
    const collection = document.querySelector(collectionSelector);
    if (!grid || !collection) return;

    const itemCount = grid.querySelectorAll(itemSelector).length;
    const perPage = Number(collection.dataset.perPage || 0);
    if (!perPage || itemCount <= perPage) {
      sessionStorage.removeItem(storageKey);
      return;
    }

    const pagination = collection.querySelector('.clc-List_Pagination');
    history.scrollRestoration = 'manual';

    try {
      sessionStorage.setItem(storageKey, JSON.stringify({
        gridHtml: grid.innerHTML,
        paginationHtml: pagination ? pagination.innerHTML : '',
        productPath: normalisePath(link.href),
        scrollY: window.scrollY,
        savedAt: Date.now()
      }));
    } catch (error) {
      sessionStorage.removeItem(storageKey);
      history.scrollRestoration = 'auto';
    }
  }, true);

  window.addEventListener('pageshow', (event) => {
    if (!event.persisted) return;

    const state = readState();
    if (!state) return;

    const grid = document.querySelector(gridSelector);
    const productLink = grid && Array.from(grid.querySelectorAll('a[href*="/products/"]'))
      .find((link) => normalisePath(link.href) === state.productPath);

    requestAnimationFrame(() => {
      if (productLink) {
        productLink.closest(itemSelector).scrollIntoView({ block: 'center' });
      } else {
        window.scrollTo(0, state.scrollY);
      }
      sessionStorage.removeItem(storageKey);
    });
  });
})();
